const [ w, d ] = [ window, document ]

export default function ABOUT() {
  
  const delayCurrentNav = () => $('[data-plugin="currentMenu"]').currentMenu({mode:0,default:999})
  
  $(() => {
    w.load['nav-about-head'].then( delayCurrentNav )
    w.load['nav-about-foot'].then( delayCurrentNav )
  })

}